import { render, staticRenderFns } from "./categoryTags.vue?vue&type=template&id=ff87b67c&"
import script from "./categoryTags.vue?vue&type=script&lang=js&"
export * from "./categoryTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports